import useSWRImmutable from 'swr/immutable';

const BASE_THUMBNAIL_URL = '/infographics/icons8_img_thumbnail/';

const thumbnailFetcher = (key: string) => {
  const [, iconId] = key.split('/');

  return fetch(`${BASE_THUMBNAIL_URL}${iconId}`).then((res) => res.blob());
};

/**
 * Hook to fetch icons8 thumbnail as a blob using E1 endpoint
 *
 * Note: Using this endpoint will *not* count towards our quota
 *
 * @param iconId
 */
export const useIcons8Thumbnail = (iconId: string) => {
  const { data, error } = useSWRImmutable<Blob>(`ICONS8-THUMBNAIL/${iconId}`, thumbnailFetcher);

  return { data, error };
};
